import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  PaymentErrorCodeTypes,
  PaymentOutboundSyncStatuses,
} from '@webapp/models/enums'
import { type PaymentError } from '@webapp/models/PaymentError'

export const PaymentErrorMock = Factory.Sync.makeFactory<PaymentError>({
  id: Factory.each(() => faker.random.number()),
  payment_id: Factory.each(() => faker.random.number()),
  error_code: PaymentErrorCodeTypes.INSUFFICIENT_FUNDS,
  error_message: 'Some Error Message',
  status: PaymentOutboundSyncStatuses.RETURNED_FROM_VENDOR,
  sync_datetime: Factory.each(() => {
    return new Date().toISOString()
  }),
})
